<template>
    <div class="container pt-5">

        <div class="row justify-content-center mb-5">
            <div class="col-10 col-md-8 col-lg-5 text-center">
                <img src="../../assets/logo.png" alt="Logo" class="img-fluid">
            </div>
        </div>

        <h3 class="text-center mb-5">Sign in</h3>

        <div class="row justify-content-center">
            <div class="col-12 col-md-4">
                <form method="post" @submit.prevent="signUp">
                    <b-form-group
                            id="loginName"
                            label="Enter your name"
                            label-for="loginName_in">
                        <b-form-input id="loginName_in"
                                      type="text" placeholder="John Doe" v-model="name" trim></b-form-input>
                    </b-form-group>
                    <b-form-group
                            id="loginInput"
                            label="Enter email"
                            label-for="loginInput_in">
                        <b-form-input id="loginInput_in"
                                      type="email" placeholder="@" v-model="email" trim></b-form-input>
                    </b-form-group>

                    <b-form-group
                            id="loginPassword"
                            label="Enter password"
                            label-for="loginPassword_in">
                        <b-form-input id="loginPassword_in"
                                      type="password" placeholder="*****" v-model="password" trim></b-form-input>
                    </b-form-group>
                    <b-form-group
                            id="loginPasswordVerify"
                            label="Enter password again"
                            label-for="loginPasswordVer_in">
                        <b-form-input id="loginPasswordVer_in"
                                      type="password" placeholder="*****" v-model="passwordVerify"
                                      trim></b-form-input>
                    </b-form-group>

                    <b-button :block="true" variant="primary" type="submit" :disabled="this.saving">
                        Create Account
                    </b-button>
                    <b-alert :show="responseState !== null" class="mt-3"
                             :variant="responseState ? (responseState.status === 'success' ? 'success' : 'danger') : 'default'">
                        {{responseState ? responseState.message : ''}}
                    </b-alert>
                </form>
                <br>
                <router-link to="/login">Already have an account?</router-link>
                <br>
                <div class="text-center mt-5">
                    <p class="mb-5">OR</p>
                    <div class="row">
                        <div class="col-3">
                            <button @click="logInWithProvider('google')" title="Google log in" class="socialIcon gg">
                                <fa-icon :icon="['fab', 'google']"/>
                            </button>
                        </div>
                        <div class="col-3">
                            <button @click="logInWithProvider('github')" title="GitHub log in" class="socialIcon git">
                                <fa-icon :icon="['fab', 'github']"/>
                            </button>
                        </div>
                        <div class="col-3">
                            <button @click="logInWithProvider('microsoft')" title="Microsoft log in"
                                    class="socialIcon ms">
                                <fa-icon :icon="['fab', 'microsoft']"/>
                            </button>
                        </div>
                        <div class="col-3">
                            <button @click="logInWithProvider('yahoo')" title="Yahoo log in"
                                    class="socialIcon yh">
                                <fa-icon :icon="['fab', 'yahoo']"/>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
    import User from "../../lib/models/User"
    import GoogleSignIn from "@/lib/mixins/GoogleSignIn";
    import GithubSignIn from "@/lib/mixins/GithubSignIn";
    import MicrosoftSignIn from "@/lib/mixins/MicrosoftSignIn";
    import YahooSignIn from "@/lib/mixins/YahooSignIn";
    import UserMixin from "@/lib/mixins/UserMixin";

    export default {
        name: "Login",
        data() {
            return {
                email: null,
                password: null,
                name: null,
                passwordVerify: null,
                saving: false,
                responseState: null
            }
        },
        mixins: [
            UserMixin,
            GoogleSignIn,
            GithubSignIn,
            MicrosoftSignIn,
            YahooSignIn
        ],
        methods: {
            signUp: function () {
                this.responseState = null;
                this.saving = true;

                this.$firebase.auth().createUserWithEmailAndPassword(String(this.email), String(this.password)).then(({user}) => {

                    this.$firebase.database().ref('/users/' + user.uid).once('value').then((snapshot) => {
                        if (snapshot.val() === null) {
                            this.$firebase.database().ref('users/' + user.uid).set((new User()).fromObject({
                                uid: user.uid,
                                name: this.name,
                                email: user.email,
                                verified: false
                            })).then(() => {
                                this.saving = false;
                                this.responseState = {
                                    status: "success",
                                    message: "User created successfully. Log in to your account."
                                };
                            }, (err) => {
                                this.saving = false;
                                console.log(err.message);
                                this.responseState = {
                                    status: "success",
                                    message: "User created successfully. Log in to your account."
                                };
                            });
                        } else {
                            this.saving = false;
                            return {
                                status: "success",
                                message: "User created successfully. Log in to your account.",
                                user: user
                            };
                        }
                    });

                    /*this.$firebase.database().ref('users/' + user.uid).set((new User()).fromObject({
                        email: this.email,
                        verified: false,
                        emailVerified: false,
                    })).then(() => {
                        user.sendEmailVerification({
                            url: `${process.env.VUE_APP_URL}/sign-up-verification?cid=${user.uid}`
                        }).then(() => {
                            this.saving = false;
                            this.responseState = {
                                status: "success",
                                message: "User created successfully. Verification email sent to your email address."
                            };
                        }).catch((err) => {
                            this.saving = false;
                            this.responseState = {status: "error", message: err.message};
                        });
                    }, (err) => {
                        this.saving = false;
                        this.responseState = {status: "error", message: err.message};
                    });
*/

                }, (err) => {
                    this.responseState = {status: "error", message: err.message};
                    this.saving = false;
                    setTimeout(() => {
                        this.responseState = null;
                    }, 5000);
                });
            },
            reloadUserAndRedirect(user) {
                this.reloadUser(user, () => {
                    setTimeout(() => {
                        this.$router.push({path: "/app"});
                    }, 200);
                });
            },
            logInWithProvider(provider) {
                this.responseState = null;
                this.saving = true;

                if (provider === 'google') {
                    this.signInUsingGoogle().then((status) => {
                        this.saving = false;
                        this.responseState = status;
                        if (status.status === 'success') {
                            this.reloadUserAndRedirect(status.user);
                        }
                    })
                } else if (provider === 'github') {
                    this.signInUsingGithub().then((status) => {
                        this.saving = false;
                        this.responseState = status;
                        if (status.status === 'success') {
                            this.reloadUserAndRedirect(status.user);
                        }
                    })
                } else if (provider === 'microsoft') {
                    this.signInUsingMicrosoft().then((status) => {
                        this.saving = false;
                        this.responseState = status;
                        if (status.status === 'success') {
                            this.reloadUserAndRedirect(status.user);
                        }
                    })
                } else if (provider === 'yahoo') {
                    this.signInUsingYahoo().then((status) => {
                        this.saving = false;
                        this.responseState = status;
                        if (status.status === 'success') {
                            this.reloadUserAndRedirect(status.user);
                        }
                    })
                }

            }
        }
    }
</script>


<style lang="scss">
    button.socialIcon {
        background-color: #e8e8e8;
        border-radius: 100%;
        text-align: center;
        border: none;
        outline: none;
        padding: 4px;
        font-size: 24px;
        width: 44px;
        height: 44px;
        transition: all .4s;

        &:hover {
            &.ms {
                background-color: #00A4EF;
                color: white;
            }

            &.gg {
                background-color: #DB4437;
                color: white;
            }

            &.git {
                background-color: #24292e;
                color: white;
            }

            &.yh {
                background-color: #430297;
                color: white;
            }
        }
    }
</style>

